export enum CommunitySubEnum {
    ElectiPlus = "Electi+"
}